import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, CircularProgress, Box } from '@mui/material';
import { GetallStagesWithLeadsCount_For_Marketer_Dashboard_Action } from '../../Redux/Actions/UsersAction';
import TrendingUpIcon        from '@mui/icons-material/TrendingUp';
import TipsAndUpdatesIcon    from '@mui/icons-material/TipsAndUpdates';
import BookmarkIcon          from '@mui/icons-material/Bookmark';
import AccessTimeFilledIcon  from '@mui/icons-material/AccessTimeFilled';
import AccessAlarmIcon       from '@mui/icons-material/AccessAlarm';
import TaskAltIcon           from '@mui/icons-material/TaskAlt';
import PhonelinkEraseIcon    from '@mui/icons-material/PhonelinkErase';
import ThumbUpIcon           from '@mui/icons-material/ThumbUp';
import CancelIcon            from '@mui/icons-material/Cancel';
import WorkHistoryIcon       from '@mui/icons-material/WorkHistory';
import BackspaceIcon         from '@mui/icons-material/Backspace';
import AccessibilityNewIcon  from '@mui/icons-material/AccessibilityNew';
import ControlPointDuplicateOutlinedIcon from '@mui/icons-material/ControlPointDuplicateOutlined';
import HourglassEmptyOutlinedIcon        from '@mui/icons-material/HourglassEmptyOutlined';
import DoNotDisturbOnOutlinedIcon        from '@mui/icons-material/DoNotDisturbOnOutlined';
import ArrowCircleLeftOutlinedIcon       from '@mui/icons-material/ArrowCircleLeftOutlined';
import EventRepeatOutlinedIcon           from '@mui/icons-material/EventRepeatOutlined';
import PersonAddAltOutlinedIcon          from '@mui/icons-material/PersonAddAltOutlined';

/* ── icons map ───────────────────────────────────────────────────── */
const stagesIcons = {
  'Fresh'                : <TipsAndUpdatesIcon    style={{ fontSize: 18 }} />,
  'Follow Up'            : <HourglassEmptyOutlinedIcon style={{ fontSize: 18 }} />,
  'Follow'               : <PersonAddAltOutlinedIcon  style={{ fontSize: 18 }} />,
  'Long Follow'          : <EventRepeatOutlinedIcon   style={{ fontSize: 18 }} />,
  'Interested'           : <ThumbUpIcon           style={{ fontSize: 18 }} />,
  'Not Interested'       : <DoNotDisturbOnOutlinedIcon style={{ fontSize: 18 }} />,
  'Meeting'              : <AccessTimeFilledIcon  style={{ fontSize: 18 }} />,
  'Follow After Meeting' : <WorkHistoryIcon        style={{ fontSize: 18 }} />,
  'Done Deal'            : <TaskAltIcon            style={{ fontSize: 18 }} />,
  'No Answer'            : <PhonelinkEraseIcon     style={{ fontSize: 18 }} />,
  'No Answer 1st Call'   : <AccessAlarmIcon        style={{ fontSize: 18 }} />,
  'Cancellation'         : <CancelIcon             style={{ fontSize: 18 }} />,
  'Cancel Meeting'       : <CancelIcon             style={{ fontSize: 18 }} />,
  'Transfer'             : <ArrowCircleLeftOutlinedIcon style={{ fontSize: 18 }} />,
  'Duplicate'            : <ControlPointDuplicateOutlinedIcon style={{ fontSize: 18 }} />,
};

/* ── number colour per stage ─────────────────────────────────────── */
const numberColor = (stageName) => {
  if (!stageName) return null;
  const n = stageName.toLowerCase();
  if (n.includes('cancel'))         return '#C62828';
  if (n.includes('not interested')) return '#C62828';
  if (n.includes('cancellation'))   return '#C62828';
  if (n.includes('pending'))        return '#B8860B';
  if (n.includes('done deal'))      return '#1B5E20';
  if (n.includes('reservation'))    return '#1B5E20';
  if (n.includes('eoi'))            return '#0D47A1';
  return null;
};

/* ── badge style ─────────────────────────────────────────────────── */
const trendStyle = (pct) => {
  if (pct > 0)   return { bg: '#EBF2FF', color: '#1A3ECF' };
  return           { bg: '#F3F4F6',  color: '#6B7280' };
};

/* ══════════════════════════════════════════════════════════════════ */
export const QuickNumbersForMarketer = ({ darkMode = false }) => {
  const theme    = useTheme();
  const dark     = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userlogin,            setUserLogin]            = useState(null);
  const [loading,              setLoading]              = useState(true);
  const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
  const [totalCustomers,       setTotalCustomers]       = useState(0);

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) setUserLogin(JSON.parse(user));
  }, []);

  const resAllStagesWithleadscount = useSelector(
    (state) => state.Allusers.Stages_With_LeadsCount_Marketer,
  );

  useEffect(() => {
    const fetchData = async () => {
      if (!userlogin?.data?._id) return;
      setLoading(true);
      await dispatch(
        GetallStagesWithLeadsCount_For_Marketer_Dashboard_Action(userlogin?.data?._id),
      );
    };
    fetchData();
  }, [dispatch, userlogin]);

  useEffect(() => {
    if (resAllStagesWithleadscount?.data) {
      setStageLeadscountarray(resAllStagesWithleadscount.data);
      setTotalCustomers(resAllStagesWithleadscount.totalLeads || 0);
      setLoading(false);
    }
  }, [resAllStagesWithleadscount]);

  const refreshLeads = () => {
    localStorage.removeItem('stagestorage');
    navigate('/ALLLeadsForMarketer');
  };

  const handleStageClick = (stageId) => {
    localStorage.setItem('stagestorage', stageId);
    navigate(`/ALLLeadsForMarketer?stage=${encodeURIComponent(stageId)}`);
    setTimeout(() => { window.dispatchEvent(new Event('stageFilterUpdated')); }, 100);
  };

  const handleGoToDuplicates = () => {
    navigate('/ALLLeadsForMarketer?duplicates=true&ignoreduplicate=true');
  };

  /* ── حساب النسبة الحقيقية من total ── */
  const calcPct = (count) => {
    if (!totalCustomers || totalCustomers === 0) return 0;
    return Math.round((count / totalCustomers) * 100);
  };

  /* ── tokens ── */
  const cardBg  = dark ? '#1E1E2E' : '#FFFFFF';
  const border  = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';
  const textPri = dark ? '#E2E8F0' : '#111827';
  const textSec = dark ? '#94A3B8' : '#9CA3AF';
  const accent  = '#1A3ECF';

  if (loading && stageLeadscountarray.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={300}>
        <CircularProgress style={{ color: accent }} />
      </Box>
    );
  }

  /* ── single card — نفس ديزاين QuickNumbers بالظبط ── */
  const Card = ({ stageName, leadCount, onClick, pct }) => {
    const ts     = trendStyle(pct);
    const numCol = numberColor(stageName) || (dark ? '#E2E8F0' : '#111827');
    const icon   = stagesIcons[stageName] || <BookmarkIcon style={{ fontSize: 18 }} />;

    return (
      <div
        onClick={onClick}
        style={{
          background    : cardBg,
          border        : `1px solid ${border}`,
          borderRadius  : 16,
          padding       : '24px 22px 20px',
          cursor        : 'pointer',
          position      : 'relative',
          transition    : 'box-shadow 0.18s, transform 0.18s',
          display       : 'flex',
          flexDirection : 'column',
          justifyContent: 'space-between',
          minHeight     : 115,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.08)';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = 'none';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        {/* badge بالنسبة الحقيقية */}
        <div style={{
          position    : 'absolute',
          top         : 16,
          right       : 16,
          display     : 'flex',
          alignItems  : 'center',
          gap         : 2,
          fontSize    : 11,
          fontWeight  : 600,
          color       : ts.color,
          background  : ts.bg,
          borderRadius: 20,
          padding     : '3px 8px',
          lineHeight  : 1,
        }}>
          {pct > 0 && <TrendingUpIcon style={{ fontSize: 12 }} />}
          {pct}%
        </div>

        {/* icon صغير فوق الرقم */}
        <div style={{
          color      : numberColor(stageName) || accent,
          opacity    : 0.55,
          marginBottom: 6,
          lineHeight : 1,
        }}>
          {icon}
        </div>

        {/* big number */}
        <div style={{
          fontSize     : 42,
          fontWeight   : 800,
          color        : numCol,
          lineHeight   : 1,
          fontFamily   : "'DM Sans', sans-serif",
          letterSpacing: '-1.5px',
        }}>
          {typeof leadCount === 'number' ? leadCount.toLocaleString() : leadCount}
        </div>

        {/* stage label */}
        <div style={{
          fontSize     : 11,
          fontWeight   : 600,
          letterSpacing: '0.09em',
          color        : textSec,
          marginTop    : 16,
          textTransform: 'uppercase',
        }}>
          {stageName}
        </div>
      </div>
    );
  };

  /* ── render ── */
  return (
    <div style={{ width: '100%' }}>

      {/* section header — نفس QuickNumbers */}
      <div style={{
        display       : 'flex',
        justifyContent: 'space-between',
        alignItems    : 'flex-start',
        marginBottom  : 22,
      }}>
        <div>
          <h2 style={{
            margin    : 0,
            fontSize  : 20,
            fontWeight: 700,
            color     : textPri,
            fontFamily: "'DM Sans', sans-serif",
          }}>
            Quick Numbers
          </h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: textSec }}>
            Real-time engagement metrics for your portfolio
          </p>
        </div>

        <button
          onClick={() => navigate('/QuickNumbersForMarketerCRMDATA')}
          style={{
            background    : 'none',
            border        : 'none',
            cursor        : 'pointer',
            color         : accent,
            fontSize      : 13,
            fontWeight    : 700,
            fontFamily    : "'DM Sans', sans-serif",
            textDecoration: 'none',
            padding       : 0,
          }}
          onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
          onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
        >
          View Data Center
        </button>
      </div>

      {/* card grid */}
      <div style={{
        display            : 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap                : 16,
      }}>
        {/* All Leads — 100% دايماً */}
        <Card
          stageName ="All Leads"
          leadCount ={totalCustomers}
          onClick   ={refreshLeads}
          pct       ={100}
        />

        {/* Duplicate */}
        {stageLeadscountarray
          .filter((s) => s.stageName === 'Duplicate')
          .map(({ stageId, stageName, leadCount }) => (
            <Card
              key      ="dup"
              stageName={stageName}
              leadCount={leadCount}
              onClick  ={handleGoToDuplicates}
              pct      ={calcPct(leadCount)}
            />
          ))}

        {/* All other stages */}
        {stageLeadscountarray
          .filter((s) => s.stageName !== 'Duplicate')
          .map(({ stageId, stageName, leadCount }) => (
            <Card
              key      ={stageId}
              stageName={stageName}
              leadCount={leadCount}
              onClick  ={() => handleStageClick(stageId)}
              pct      ={calcPct(leadCount)}
            />
          ))}
      </div>
    </div>
  );
};
